import { CSSObject } from '@emotion/react'
import { Spacing } from '@opallabs/gem'

export const dropdownContent: CSSObject = {
  minInlineSize: 240,
}

export const dropdownItemIcon: CSSObject = {
  marginInlineEnd: Spacing.XS,
}
